import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4ee43c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base multiple-sessions-container" }

import AuthState from '@/services/auth-state'
import { useRouter } from 'vue-router'

interface MultipleSessionsDetectedPopupEmits {
  (e: 'update:modelValue', value: boolean): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleSessionsDetectedPopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {



const router = useRouter()
const emit = __emit

const continuePage = () => {
  AuthState.removeCountRoomTab()
  router.go(0)
  emit('update:modelValue', false)
}

const endPage = () => {
  AuthState.removeCountRoomTab()
  router.replace({ path: 'end' })
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: _ctx.$t('multiple-session-title'),
    "can-close": false,
    open: __props.modelValue,
    onClose: endPage
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn bg-gray-400 text-white text-base w-full",
        onClick: continuePage
      }, _toDisplayString(_ctx.$t('continue-session-button')), 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn bg-red-500 text-white text-base w-full mt-2",
        onClick: endPage
      }, _toDisplayString(_ctx.$t('end-session-button')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('multiple-session-message')), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "open"]))
}
}

})